module.exports = __webpack_public_path__ + "img/gift-clubfun-icon5.f3ee9653.png";